import React, { useEffect, useState } from "react";
import { DATE_FORMATS } from "../../../../../constants";
import { Header, FloatingHeader } from "./Header";
import Exercises from "./Exercises";
import SvgIcon from "../../../../../parts/SvgIcon";
import { PasteExerciseComponent } from "../../../../../parts/PasteExerciseComponent";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const DayNormal = ({
  isInActiveMonth,
  isPast,
  isToday,
  expanded,
  exercises,
  dayString,
  dragging,
  date,
  handleSelectDate,
  selectedDates,
  handleRemoveMultiple,
  supersets,
  withWeight,
  fromMetric,
  units,
  round,
  program,
  intensityMeasure,
  isRiR,
  mobile = false,
  removing,
  athlete,
  query,
}) => {
  const [exercisesToCopy, setExercisesToCopy] = useState(null);
  const exercisesInClipboard = query?.exercisesInClipboard;
  /** 
   * Check if there is an exercise storage and ready to be pasted
   */
  useEffect(() => {
    if (typeof window !== "undefined") {
      const exerciseInLocalStorage =
        localStorage.getItem("exercisesToCopy");
      setExercisesToCopy(
        exerciseInLocalStorage ? JSON.parse(exerciseInLocalStorage) : null
      );
    }
  }, [exercisesInClipboard]);

  return (
    <div
      className={`day ${!isInActiveMonth ? " alt-other-month" : ""}${
        isPast ? " alt-past" : isToday ? " alt-today" : ""
      }${expanded ? " expanded" : ""}${
        !exercises.length ? " empty-workout-day" : ""
      } ${
        removing && !selectedDates.includes(dayString)
          ? " unselected"
          : removing && selectedDates.includes(dayString)
          ? " selected"
          : ""
      }`}
    >
      <div
        className={`day-margin${
          exercises.length ? " draggable-dropzone--occupied" : ""
        }${expanded ? " expanded" : ""}`}
        id={`container-${dayString}`}
      >
        <Header
          date={date}
          mobile={mobile}
          program={program}
          handleSelectDate={handleSelectDate}
          selectedDates={selectedDates}
          handleRemoveMultiple={handleRemoveMultiple}
          dayString={dayString}
          removing={removing}
        />
        {exercises.length ? (
          <div className="day-draggable" id={dayString}>
            {!mobile && (
              <FloatingHeader
                handleSelectDate={handleSelectDate}
                selectedDates={selectedDates}
                handleRemoveMultiple={handleRemoveMultiple}
                date={date}
                dayString={dayString}
                removing={removing}
                exercises={exercises}
                athlete={athlete}
              />
            )}
            <Exercises
              exercises={exercises}
              supersets={supersets}
              withWeight={withWeight}
              fromMetric={fromMetric}
              units={units}
              round={round}
              expanded={expanded}
              date={date}
              intensityMeasure={intensityMeasure}
              isRiR={isRiR}
              mobile={mobile}
              athlete={athlete}
            />
          </div>
        ) : null}
        {!dragging ? (
          exercisesToCopy && exercises.length === 0 ? (
            <div className="add-paste-exercise">
              <AddExerciseButton date={date} classNames="add-paste" />
              <PasteExerciseComponent
                athlete={athlete}
                date={date.format(DATE_DAY_FORMAT)}
                withFullInfo={true}
                classNames="add-paste"
                isProgram={false}
                query={query?.exercisesInClipboard}
              />
            </div>
          ) : (
            <AddExerciseButton date={date} classNames="add" />
          )
        ) : null}
      </div>
    </div>
  );
};

export default DayNormal;

const AddExerciseButton = ({ date, classNames }) => (
  <a
    className={classNames}
    href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${date.format(
      DATE_DAY_FORMAT
    )}`}
  >
    <SvgIcon
      src="/img/new-icons/add-square-outline.svg"
      className="h-11 w-11"
    />
    <p className="p4 text-center">Add Exercise</p>
  </a>
);
